/* custom variables */ // references: (js + scss)
export const petcoBlue = "#001952"; // 1 + 35
export const blueNeutral = "#7792C6"; // 0 + 4
export const neutralFog = "#F8F7F9";
export const petcoSecondaryGreen = "#A9F4CD";

export const petcoBodyBG = "#F5F5F5"; // 1 + 4
export const petcoText = "#000000"; // 10 + 0
export const petcoWhite = "#FFFFFF" // 16 + 29
export const petcoRed = "#FF5630"; // 0 + 1 // diff
export const petcoSmoke = "#EBECEE"; // 0 + 1 // diff
export const petcoGray = "#E2E2E2"; // 0 + 1
export const petcoGreen = "#007500"; // 0 + 1
export const petcoWarning = "#FFF3CD"; // 1 + 1 // diff
export const petcoDanger = "#E02924"; // 2 + 7 // diff
export const petcoLightBlue = "#73EAFF"; // 0 + 4
export const petcoPastelRed = "#FC6666"; // 0 + 1

/* new custom variables, potentially to be removed */
// colors that also exist in figma
export const petcoCyan = "#8BE8D7"; // 0 + 3

export const petcoSpanishGray = "#979797" // 10 + 2
export const petcoGraniteGray = "#656565" // 2 + 12
export const petcoCharcoal = "#333333" // 3 + 12
export const petcoCharcoal10 = "#3333331A" // 3 + 12

export const petcoGreenSuccess = "#007500" // 0 + 0
export const petcoMyrtleGreen = "#2F7B6E" // 1 + 6
export const petcoUCLABlue = "#4C699E" // 1 + 0
export const petcoTintGreen = "#E9FDF2"; // 1 + 5
export const petcoTintBlue = "#E8FAFE"; // 0 + 6
export const petcoTintRed = "#FBEEEC"

export const petcoPlatinum = "#E5E5E5"; // 0 + 2
export const petcoBrightGray3 = "#EBEBEB"; // 0 + 1
export const petcoAntiFlashWhite = "#F2F3F6"; // 0 + 3
export const petcoAntiFlashWhite2 = "#F2F4F6"; // 0 + 1
export const petcoLavenderPink = "#F8B1CA"; // 0 + 2
export const petcoBrightYellowCrayola = "#FFA826"; // 0 + 1
export const petcoDeepGreenCyanTurquoise = "#217465"; // 0 + 2 // calendar pills
export const petcoDeepGreenCyanTurquoise2 = "#1F6D60" // 0 + 2 // calendar pills
export const petcoAeroBlue = "#C3F4EB"; // 0 + 2 // calendar pills
export const petcoMagicMint = "#9BF1E1"; // 0 + 2 // calendar pills
export const petcoDiamond2 = "#B9EDFF"; // 0 + 2 // calendar pills
export const petcoWater = "#D0F3FF";// 0 + 1 // calendar pills
export const petcoChineseSilver = "#CCCCCC"; // 0 + 2
export const petcoGreenSheen = "#71C2B4";
export const petcoLavender2= "#AC74D6";
export const petcoLilac="#E6D6F2";


export const petcoChalk = "#F2F2F2"; // 0 + 5
export const petcoPink = "#F26E9D";
export const petcoLightPink = "#FCE0EA";

// do not exist in figma
export const petcoBrightGray2 = "#EDEDED" // 1 + 1
export const petcoPewterBlue = "#84C0B4" // 6 + 0
export const petcoGrayX11 = "#BBBBBB" // 12 + 0
export const petcoBrightGray = "#EEEEEE" // 7 + 0
export const petcoChineseWhite = "#E0E0E0"; // 0 + 5
export const petcoLotion = "#FAFAFA"; // 0 + 1
export const petcoCetaceanBlue = "#040D4A"; // 1 + 0
export const petcoOxfordBlue = "#06184E"; // 0 + 1
export const petcoDarkJungleGreen = "#151E27"; // 0 + 1
export const petcoDarkGunmetal = "#1A252F"; // 0 + 2
export const petcoYankeesBlue = "#1E2B37"; // 0 + 1
export const petcoDarkGunmetal2 = "#212529"; // 0 + 2
export const petcoDodgerBlue = "#2684FF"; // 0 + 2
export const petcoPalatinateBlue = "#2842F7"; // 1 + 0
export const petcoJapaneseIndigo = "#2C3E50"; // 0 + 2
export const petcoOnyx = "#343A40"; // 1 + 1
export const petcoJet = "#363636"; // 0 + 2
export const petcoTuftsBlue = "#3788D8"; // 0 + 2
export const petcoCeruleanBlue = "#2C60C0"; // 0 + 3
export const petcoPhilippineBronze = "#663300"; // 1 + 0
export const petcoPewterBlue2 = "#83C0B4"; // 0 + 1
export const petcoPaleRobinEggBlue = "#8BE8D7"; // 0 + 1
export const petcoInternationalOrange = "#C73025"; // 0 + 2
export const petcoFieldDrab = "#786025"; // 0 + 2
export const petcoTintYellow = "#FDFBE8"; // 0 + 1
export const petcoLavender = "#DEEBFF"; // 0 + 1
export const petcoCultured2 = "#F4F6F6"; // 0 + 1
export const petcoCultured = "#F6F6F6"; // 2 + 0
export const petcoAliceBlue = "#EAEFF9"; // 2 + 0
export const petcoSnow = "#FEF7F7"; // 0 + 1
export const petcoAmericanSilver = "#D0D0D0"; // 0 + 1
export const petcoRustyRed = "#DC3545"; // 1 + 0
export const petcoLightCyan2 = "#E2F9F5"; // 0 + 1
export const petcoLightCarminePink = "#EA706B"; // 1 + 0
export const petcoRed2 = "#FF0000"; // 1 + 0
export const petcoMikadoYellow = "#FFC107"; // 1 + 0
export const petcoGainsboro2 = "#DDDDDD";
export const petcoTawny = "#B45F06";
export const petcoOldLace = "#FCF5E8"; // aka, (tint orange);
export const petcoWindsorTan = "#B85300"; // 1 + 2 // aka, (Extended Burnt-WarningAttn);
export const petcoCornsilk = "#FFF2DE"; // 0 + 1 // aka, Extended/LightBurnt
export const petcoBlueSeaMonday = "#0047bbff";

export const getHexAlphaValue = (percentAsInteger) => {
    const percent = (percentAsInteger / 100);
    return percent.toString(16).slice(2, 4); // .15 returns 26
}

const transformObject = (object1) => Object.entries(object1)
// export const currentVariables = transformObject({
//     petcoBlue, blueNeutral, petcoBodyBG, petcoText, petcoWhite, petcoRed, petcoSmoke, petcoGray, petcoGreen,
//     petcoWarning, petcoDanger, petcoLightBlue, petcoTintGreen, petcoTintBlue,
// })
export const newVariablesInFigma = transformObject({
    petcoBlue, blueNeutral, petcoBodyBG, petcoText, petcoWhite, petcoRed, petcoSmoke, petcoGray, petcoGreen,
    petcoWarning, petcoDanger, petcoLightBlue, petcoTintGreen, petcoTintBlue,
    petcoCyan, petcoSpanishGray, petcoGraniteGray, petcoCharcoal,
    petcoGreenSuccess, petcoMyrtleGreen, petcoUCLABlue,
    petcoPlatinum, petcoBrightGray3, petcoAntiFlashWhite, petcoAntiFlashWhite2, petcoLavenderPink, petcoBrightYellowCrayola,
    petcoChineseSilver, petcoChalk, petcoPaleRobinEggBlue, petcoCeruleanBlue, petcoFieldDrab, petcoOldLace,
    petcoWindsorTan, petcoCornsilk, neutralFog, petcoTintYellow
})

export const newVariablesNotFigma = transformObject({
    petcoPewterBlue, petcoPewterBlue2, petcoOxfordBlue, petcoTuftsBlue, petcoJapaneseIndigo, petcoYankeesBlue,
    petcoDarkGunmetal, petcoDarkJungleGreen, petcoGrayX11, petcoAmericanSilver, petcoBrightGray, petcoChineseWhite,
    petcoCultured2, petcoCultured, petcoAliceBlue, petcoGainsboro2, petcoLightCarminePink, petcoPhilippineBronze,
    petcoInternationalOrange, petcoSnow, petcoMikadoYellow, petcoRustyRed, petcoOnyx, petcoDodgerBlue, petcoLavender,
    petcoPalatinateBlue, petcoCetaceanBlue, petcoJet, petcoDarkGunmetal2, petcoLotion, petcoSmoke, petcoWarning,
    petcoBrightGray2, petcoRed2, petcoTawny, petcoPastelRed, petcoTintRed, petcoDeepGreenCyanTurquoise2, petcoAeroBlue,
    petcoMagicMint, petcoDiamond2, petcoWater, petcoGreenSheen, petcoLightCyan2
    // do not exist in figma
    // blue
    // petcoPewterBlue, // suggestion, change to Green Sheen
    // petcoPewterBlue2, // suggestion, change to Green Sheen

    // petcoOxfordBlue, // _scheduling.scss no preferences warning. suggestion, change to petcoBlue, 
    // petcoTuftsBlue, // _calendar.scss seems to have no effect. suggestion, change to petcoBlue
    // petcoJapaneseIndigo, // _calendar.scss seems to have no effect. suggestion, change to petcoBlue
    // petcoYankeesBlue, // _calendar.scss seems to have no effect. suggestion, change to petcoPrimaryLight
    // petcoDarkGunmetal, // _calendar.scss seems to have no effect. suggestion, change to petcoPrimaryLight
    // petcoDarkJungleGreen, // _calendar.scss seems to have no effect. suggestion, change to petcoBlue

    // // gray
    // petcoGrayX11, // exam form borders, invoice
    // petcoAmericanSilver, // _calendar.scss, no current suggestion.
    // petcoBrightGray, // form select, exam form, disabled, recommendation petcoChalk.
    // petcoChineseWhite, // _page.scss border for section break and navbar accordion. recommendation  petcoPlatinum

    // petcoCultured2, // _common, mainBody bgColor, recommendation: petcoBodyBG
    // petcoCultured,
    // petcoAliceBlue,

    // petcoGainsboro2, // _calendar.scss, _petcoCalendarTheme timegrid slotlane border
    // petcoLightCarminePink, // discussion
    // petcoPhilippineBronze, // discussion
    // petcoInternationalOrange, // discussion
    // petcoSnow, // discussion, _calendarPage, change to figma lavendarBlush
    // petcoMikadoYellow, // forms
    // petcoRustyRed, // forms
    // petcoOnyx, // forms
    // petcoDodgerBlue, // react-select ui fix.
    // petcoLavender, // react-select ui fix hover
    // petcoPalatinateBlue, // calendar container warning triangle, getVetTitle
    // petcoCetaceanBlue, // calendar container warning triangle, getVetTitle
    // petcoJet, // _calendarPage
    // petcoDarkGunmetal2, // _table.scss
    // petcoLotion, // suggestion, change to Neutral/Fog
    // petcoSmoke, // suggestion, change to platinum
    // petcoWarning, // suggestion, change to tintYellow

    // petcoBrightGray2, // no show color on card.
})
// petcoCharcoal10,

// export const quickDiscussion = transformObject({})

// export const discussion = transformObject({})

// export const laterDiscussion = transformObject({})

/* notes for alvar:
    #FB4341, coral red from figma is petco red
    #73EAFF, current lightBlue is also in the foundation design system as petco light blue
*/

// others to look at
// background-color: $orange;
